const offlineFileUploadModal = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
  templateUrl: '/modules/pis-tool/offline-audio/offline-file-upload-modal/offline-file-upload-modal.html',
  controller: 'OfflineFileUploadModalController',
};

angular
    .module('offline.module')
    .component('offlineFileUploadModal', offlineFileUploadModal);
